<template>
    <div class="container">
        <div class="col-md-12 mt-3">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="row col-md-12 mt-5">
            <div class="col-md-3 d-flex justify-content-end align-items-center">
                <h4>{{ labels.fechaIni }}</h4>
            </div>
            <div class="col-md-2 d-flex justify-content-start">
                <input type="month" v-model="fechaIni" class="form-control" style="width: 180px;">
            </div>
            <div class="col-md-3 d-flex justify-content-end align-items-center">
                <h4>{{ labels.fechaFin }}</h4>
            </div>
            <div class="col-md-2 d-flex justify-content-start">
                <input type="month" v-model="fechaFin" class="form-control" style="width: 180px;">
            </div>
        </div>
        <div class="col-md-12 mt-4">
            <b-button type="button" id="create-btn" @click="consulSaldPorContDesdHast">{{ labels.consultar }}</b-button>
        </div>
        <div class="row col-md-12 justify-content-center mt-4" v-if="lstRepSaldContrFechaDesHas != 0">
            <div v-if="btnGenExcel" class="row col-md-12 d-flex justify-content-end">
                <md-button style="background-color: #2e507a; width: 40px; height: 40px;" class="md-fab md-primary" @click="genReportSaldPorCont()">
                    <md-icon>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM291.2 329.6C283.2 319 268.2 316.8 257.6 324.8C247 332.8 244.8 347.8 252.8 358.4L290 408L252.8 457.6C244.8 468.2 247 483.2 257.6 491.2C268.2 499.2 283.2 497 291.2 486.4L320 448L348.8 486.4C356.8 497 371.8 499.2 382.4 491.2C393 483.2 395.2 468.2 387.2 457.6L350 408L387.2 358.4C395.2 347.8 393 332.8 382.4 324.8C371.8 316.8 356.8 319 348.8 329.6L320 368L291.2 329.6z"/></svg>
                    </md-icon>
                </md-button>
            </div>
            <b-table
                :items="lstRepSaldContrFechaDesHas"
                :fields="fields"
                hover
                bordered
                responsive
                sticky-header="500px"
                small
                class="tblEstandar"
                head-variant="custom-blue"
                :per-page="perPage"
                :current-page="currentPage"
            >
                <template #cell()="data">
                    <div
                        :class="{
                            'text-right': typeof data.value === 'number' || !isNaN(data.value),
                            'text-left': isNaN(data.value)
                        }"
                    >
                        {{ isNaN(data.value) ? data.value : formatNumber(data.value) }}
                    </div>
                </template>
            </b-table>
            <div class="row col-12 mt-1">
                <div class="col-10 d-flex justify-content-center">
                    <b-pagination
                    v-model="currentPage"
                    :total-rows="lstRepSaldContrFechaDesHas.length"
                    :per-page="perPage"
                    align="center"
                    size="md"
                    class="custom-pagination"
                    ></b-pagination>
                </div>
                <div class="col-2 d-flex justify-content-end">
                    <label class="mr-2 mb-0">Filas por página:</label>
                    <b-form-select
                    v-model="perPage"
                    :options="[5, 10, 20, 50, 100, 500]"
                    size="sm"
                    style="width: 80px;"
                    ></b-form-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Reportes from '../../services/Reportes';
import Authentication from "../../services/Authentication";
import ExcelJS from 'exceljs'

export default {
    name : 'SaldosPorContratoDesHas',
    data : () => ({
        fechaIni : '',
        fechaFin : '',
        btnGenExcel : false,
        lstRepSaldContrFechaDesHas : [],
        mesesSeleccionados: [],
        perPage: 500,
        currentPage: 1,
        fields : [],
        nameCompania : ''
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title : 'Saldos por contrato',
                    consultar : 'Consultar',
                    fechaIni : 'Desde',
                    fechaFin : 'Hasta'
                }
            }else{
                return {
                    title : 'Contract balances',
                    consultar : 'Consult',
                    fechaIni : 'From',
                    fechaFin : 'Until'
                }
            }
        }
    },
    methods:{
        consulSaldPorContDesdHast(){
            if(this.fechaIni == '' || this.fechaFin == ''){
                this.$toast.error('Diligenciar la fecha.');
            }else{

                Reportes.generaReportSaldosPorContratFechaDesdHasta(this.fechaIni,this.fechaFin)
                .then((res) => {

                    this.lstRepSaldContrFechaDesHas = res.data.lstSaldPorContrFechDesHas

                    if(this.lstRepSaldContrFechaDesHas.length != 0){
                        this.btnGenExcel = true
                    }else{
                        this.btnGenExcel = false
                        this.$toast.error('No hay datos para la fecha.')
                    }
                })
                .catch((err) => console.log(err))
            }
        },
        generarColumnasTabla() {

            const meses = this.generarMeses(this.fechaIni, this.fechaFin)

            const columnas = [
                { key: 'nro_contrato', label: 'Contrato' },
                { key: 'arrendador', label: 'Arrendador' }
            ]

            meses.forEach(mes => {
                const sufijo = this.mesToSuffix(mes)

                columnas.push(
                    { key: `activo_derecho_uso_${sufijo}`, label: `Activo ${mes}` },
                    { key: `pasivo_final_${sufijo}`, label: `Pasivo Final ${mes}` },
                    { key: `pasivo_inicial_${sufijo}`, label: `Pasivo Inicial ${mes}` },
                    { key: `pago_capital_${sufijo}`, label: `Pago Capital ${mes}` },
                    { key: `gasto_por_amortizacion_${sufijo}`, label: `Gasto Amortización ${mes}` },
                    { key: `gasto_por_intereses_${sufijo}`, label: `Gasto Intereses ${mes}` },
                    { key: `patrimonio_neto_${sufijo}`, label: `Patrimonio ${mes}` }
                )
            })

            this.fields = columnas
        },
        async genReportSaldPorCont() {
            // Generar los meses seleccionados en formato "YYYY-MM" y "NombreMes Año"
            this.mesesSeleccionados = this.generarMeses(this.fechaIni, this.fechaFin)
            // console.log("Meses seleccionados:", this.mesesSeleccionados)

            // Preparar claves de mes seguras para buscar en e.meses
            const meses = this.mesesSeleccionados.map(m => {
                const [nombreMes, anio] = m.split(' ')
                const mesNum = (new Date(`${nombreMes} 1, ${anio}`)).getMonth() + 1
                const mesStr = `${anio}-${mesNum.toString().padStart(2, '0')}` // "2025-01"
                return { key: mesStr, label: m }
            })

            const workbook = new ExcelJS.Workbook()
            const worksheet = workbook.addWorksheet("Saldos por contrato")

            // ====== TÍTULO ======
            worksheet.addRow(["Saldos por contrato"])
            worksheet.mergeCells(1, 1, 1, 2 + meses.length * 7) // 2 fijas + 7 por cada mes
            worksheet.getCell('A1').font = { name: 'Arial', bold: true, size: 12 }
            worksheet.getCell('A1').alignment = { horizontal: 'center' }

            // =======================
            // FILA 2 - INFO GENERAL (richText)
            // =======================
            worksheet.addRow(['']);
            const totColFilDos = 2 + meses.length * 7; // mismas columnas que el título
            worksheet.mergeCells(2, 1, 2, totColFilDos); // fila 2, desde col 1 hasta total

            const cell2 = worksheet.getCell('A2');

            cell2.value = {
                richText: [
                    { text: 'Desde: ', font: { bold: true } },
                    { text: `${this.fechaIni} | ` },

                    { text: 'Hasta: ', font: { bold: true } },
                    { text: `${this.fechaFin}` }
                ]
            };

            cell2.font = { name: 'Arial', size: 12 };
            cell2.alignment = { horizontal: 'center', vertical: 'middle' };

            // =======================
            // FILA 3 - INFO GENERACION (richText)
            // =======================
            worksheet.addRow(['']);
            const totColFilTres = 2 + meses.length * 7; // mismas columnas que el título
            worksheet.mergeCells(3, 1, 3, totColFilTres); // fila 3, desde col 1 hasta total

            const cell3 = worksheet.getCell('A3');

            cell3.value = {
                richText: [

                    { text: 'Generado por: ', font: { bold: true } },
                    { text: `${this.$store.state.userName} | ` },

                    { text: 'Fecha generación: ', font: { bold: true } },
                    { text: `${this.fechaActual()} | ` },

                    { text: 'Compañía: ', font: { bold: true } },
                    { text: `${this.nameCompania}` }
                ]
            };

            cell3.font = { name: 'Arial', size: 12 };
            cell3.alignment = { horizontal: 'center', vertical: 'middle' };

            worksheet.addRow(['']);
            worksheet.mergeCells('A4:H4')

            // ====== CABECERAS ======
            const tituloCelda = ['Contrato', 'Arrendador']
            meses.forEach(m => {
                tituloCelda.push(
                    `Activo Derecho Uso ${m.label}`,
                    `Pasivo Final ${m.label}`,
                    `Pasivo Inicial ${m.label}`,
                    `Pago Capital ${m.label}`,
                    `Gasto Por Amortización ${m.label}`,
                    `Gasto Por Intereses ${m.label}`,
                    `Patrimonio Neto ${m.label}`
                )
            })

            const headerRow = worksheet.addRow(tituloCelda);

            headerRow.eachCell(cell => {
                cell.font = { name: 'Arial', size: 12, bold: true };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });

            // ====== DATOS ======
            this.lstRepSaldContrFechaDesHas.forEach(e => {
                const fila = [e.nro_contrato, e.arrendador]

                this.mesesSeleccionados.forEach(mes => {
                    const sufijo = this.mesToSuffix(mes)

                    fila.push(
                        this.formatNumber(Number(e[`activo_derecho_uso_${sufijo}`])) || 0,
                        this.formatNumber(Number(e[`pasivo_final_${sufijo}`])) || 0,
                        this.formatNumber(Number(e[`pasivo_inicial_${sufijo}`])) || 0,
                        this.formatNumber(Number(e[`pago_capital_${sufijo}`])) || 0,
                        this.formatNumber(Number(e[`gasto_por_amortizacion_${sufijo}`])) || 0,
                        this.formatNumber(Number(e[`gasto_por_intereses_${sufijo}`])) || 0,
                        this.formatNumber(Number(e[`patrimonio_neto_${sufijo}`])) || 0
                    )
                })

                worksheet.addRow(fila)
            })

            // ====== BORDES ======
            const border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };

            worksheet.eachRow((row) => {
                if (row.number <= 4) return; // 👈 omite filas 1,2,3,4

                row.eachCell((cell) => {
                    cell.border = border;
                });
            });

            // ====== ANCHO COLUMNAS ======
            worksheet.columns.forEach(column => column.width = 18)

            // ====== DESCARGAR ======
            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = "Reporte saldos por contrato.xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
            )
            downloadLink.click()
        },
        generarMeses(fechaInicio, fechaFin) {
            const meses = []

            // Convertir strings tipo "2025-01" a año/mes
            let [inicioAño, inicioMes] = fechaInicio.split('-').map(Number)
            let [finAño, finMes] = fechaFin.split('-').map(Number)

            let current = new Date(inicioAño, inicioMes - 1) // JS months: 0-11
            const fin = new Date(finAño, finMes - 1)

            while (current <= fin) {
                const nombreMes = current.toLocaleString('es-CO', { month: 'long' })
                const año = current.getFullYear()
                const nombreFormateado =
                    nombreMes.charAt(0).toUpperCase() + nombreMes.slice(1)

                meses.push(`${nombreFormateado} ${año}`)

                current.setMonth(current.getMonth() + 1)
            }

            return meses
        },
        mesToSuffix(mes) {
            return mes.toLowerCase().replace(' ', '_')
        },
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);
        },
        fechaActual(){
            const fecha = new Date()

            const año = fecha.getFullYear()
            const mes = String(fecha.getMonth() + 1).padStart(2, '0') // getMonth() va de 0 a 11
            const dia = String(fecha.getDate()).padStart(2, '0')

            return `${año}-${mes}-${dia}`
        },
    },
    mounted(){
        Authentication.leaParametros()
        .then ((result) => {
            this.nameCompania = result.data.parametros.compania
        })
        .catch((err) => console.log(err))
    }
}
</script>

<style src="../main.css">
</style>